export default {
  env: process.env.NODE_ENV || "development",
  host: !!process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL.replace("[subdomain].", "")
    : "",
  apiHost:
    process.env.REACT_APP_API_URL?.includes("api-local") &&
    window.navigator["userAgent"].includes("HeadlessChrome")
      ? "http://host.docker.internal:84/api"
      : `${process.env.REACT_APP_API_URL}/api` || "https://api.aedo.nl/api",
  //process.env.REACT_APP_API_URL || "https://api-staging.verhoeven.aedo.nl/api",
};
